var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      style: { border: "none", marginBottom: "0px", maxHeight: "100%" },
      attrs: { grow: "", shrink: "" },
    },
    [
      _vm.$wf.isMdUp
        ? _c(
            "w-card-content",
            { style: { flexGrow: 0, flexShrink: 0 } },
            [_c("app-calendar-controls", { attrs: { state: _vm.state } })],
            1
          )
        : _vm._e(),
      _c(
        "w-card-content",
        { ref: "calContainer", staticClass: "calendar-container" },
        [
          _vm.isDayPerCalendarView
            ? _c("app-calendar-day-per-calendar-view", {
                attrs: { state: _vm.state },
                on: {
                  "edit-event": function ($event) {
                    return _vm.editEvent($event)
                  },
                  eventClick: function ($event) {
                    return _vm.handleEventClick($event)
                  },
                  eventDrop: function ($event) {
                    return _vm.onEventDrop($event)
                  },
                  eventDragStart: function ($event) {
                    return _vm.onEventDragStart()
                  },
                  eventDragStop: function ($event) {
                    return _vm.onEventDragStop($event)
                  },
                  eventResize: function ($event) {
                    return _vm.onEventResize($event)
                  },
                  eventResizeStart: function ($event) {
                    return _vm.onEventResizeStart()
                  },
                  eventResizeStop: function ($event) {
                    return _vm.onEventResizeStop()
                  },
                },
              })
            : _c("app-full-calendar", {
                ref: "fullCalendar",
                staticClass: "demo-app-calendar",
                attrs: {
                  editable: "true",
                  "scroll-time": "20:00:00",
                  "first-hour": "20:00:00",
                  height: "auto",
                  "default-view": _vm.state.defaultCalendarView,
                  "slot-label-format": _vm.timeFormat,
                  "time-format": _vm.timeFormat,
                  "event-time-format": _vm.timeFormat,
                  header: false,
                  plugins: _vm.calendarPlugins,
                  weekends: true,
                  "week-numbers": true,
                  "week-numbers-within-days": true,
                  "week-number-calculation": "ISO",
                  "week-label": "W",
                  "first-day": _vm.firstDay,
                  "event-sources": _vm.calendarEventSources,
                  views: _vm.views,
                },
                on: {
                  dateClick: function ($event) {
                    return _vm.handleDateClick($event)
                  },
                  eventClick: function ($event) {
                    return _vm.handleEventClick($event)
                  },
                  eventDrop: function ($event) {
                    return _vm.onEventDrop($event)
                  },
                  eventDragStart: function ($event) {
                    return _vm.onEventDragStart()
                  },
                  eventDragStop: function ($event) {
                    return _vm.onEventDragStop($event)
                  },
                  eventResize: function ($event) {
                    return _vm.onEventResize($event)
                  },
                  eventResizeStart: function ($event) {
                    return _vm.onEventResizeStart()
                  },
                  eventResizeStop: function ($event) {
                    return _vm.onEventResizeStop()
                  },
                  eventRender: function ($event) {
                    return _vm.state.onEventRender($event)
                  },
                },
                nativeOn: {
                  touchstart: function ($event) {
                    return _vm.onTouchStart($event)
                  },
                  mousedown: function ($event) {
                    return _vm.onMouseDown($event)
                  },
                },
              }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditEvent != null } },
        [
          _vm.toEditEvent
            ? _c("app-calendar-event-edit", {
                attrs: { "max-width": "580", event: _vm.toEditEvent },
                on: {
                  close: function ($event) {
                    _vm.toEditEvent = null
                  },
                  save: function ($event) {
                    return _vm.refresh()
                  },
                  delete: function ($event) {
                    return _vm.refresh()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditGoogleEvent != null } },
        [
          _vm.toEditGoogleEvent
            ? _c("app-google-calendar-event-edit", {
                attrs: {
                  "max-width": "700",
                  event: _vm.toEditGoogleEvent,
                  "src-calendar-id": _vm.toEditGoogleEventCalendarId,
                },
                on: {
                  close: function ($event) {
                    _vm.toEditGoogleEvent = null
                  },
                  save: function ($event) {
                    return _vm.refresh()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditTask != null } },
        [
          _vm.toEditTask
            ? _c("app-task-edit", {
                attrs: { "max-width": "700", task: _vm.toEditTask },
                on: {
                  saved: function ($event) {
                    return _vm.refresh()
                  },
                  deleted: function ($event) {
                    return _vm.refresh()
                  },
                  close: function ($event) {
                    _vm.toEditTask = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.newEventModal,
            callback: function ($$v) {
              _vm.newEventModal = $$v
            },
            expression: "newEventModal",
          },
        },
        [
          _c("app-event-type-select-modal", {
            on: {
              close: function ($event) {
                _vm.newEventModal = false
              },
              eventType: function ($event) {
                return _vm.onGotEventType($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toViewTask != null } },
        [
          _vm.toViewTask
            ? _c("app-task-view", {
                attrs: { task: _vm.toViewTask, folder: _vm.toViewTaskFolder },
                on: {
                  close: function ($event) {
                    return _vm.closeTaskView()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }